import { UsdPrice } from '@/components/shared/UsdPrice/UsdPrice';
import { TokenSymbol } from '@/types/tokens';
import { Box, ChakraComponent, Divider, Flex, IconProps, Text } from '@chakra-ui/react';
import { formatTokenAmount } from '@onbeam/utils';
import { TableRowMediaItem, TableRowMediaItemProps } from '@sphere/ui';
import { formatDistance, parseISO } from 'date-fns';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  mediaItemProps: TableRowMediaItemProps;
  icon: {
    Component: ChakraComponent<'svg', IconProps>;
    label: string;
  };
  currency: TokenSymbol;
  startTime: string;
  startLabel: string;
  endTime?: string;
  endLabel: string;
  tokenAmount?: number;
  usdAmount?: number;
  quantity?: number;
}

export const AccountTableItemMobile = ({
  mediaItemProps,
  icon,
  currency,
  startTime,
  startLabel,
  endTime,
  endLabel,
  tokenAmount,
  usdAmount,
  quantity,
  children,
}: Props) => {
  const { t } = useTranslation('account');

  return (
    <Box bg="gray.2" p="space.16" rounded="radius.8" mb="space.8">
      <Flex align="flex-start" justify="space-between" mb="space.16">
        <TableRowMediaItem {...mediaItemProps} />
        {children}
      </Flex>
      <Flex justify="space-between">
        <Text fontSize="xs">
          {`${startLabel} ${formatDistance(parseISO(startTime), new Date(), {
            addSuffix: true,
          })}`}
        </Text>
        {!!endTime && (
          <Text fontSize="xs">
            {`${endLabel} ${formatDistance(parseISO(endTime), new Date(), {
              addSuffix: true,
            })}`}
          </Text>
        )}
      </Flex>
      <Divider my="space.10" />
      <Flex justify="space-between">
        <Flex align="center" fontSize="xs" gap="space.8">
          <icon.Component boxSize={rem(16)} />
          {icon.label}
        </Flex>
        {tokenAmount && currency && (
          <Flex gap="space.4" fontSize="xs" lineHeight="3xl">
            <Text fontWeight="bold">{formatTokenAmount(tokenAmount, { symbol: currency })}</Text>
            {usdAmount && <UsdPrice usdValue={usdAmount} isExact prefix="(" suffix=")" />}
            {(quantity || 0) > 1 && t('offers.labels.each')}
          </Flex>
        )}
      </Flex>
    </Box>
  );
};
